import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatChipGrid, MatChipInput,MatChipInputEvent, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError,MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

import { TFolderItem } from '@core/interfaces/TFolderItem';

import { CommonService } from '@shared/services/common.service';
import { FoldersService } from '@shared/services/folders.service';

@Component({
    selector: 'app-edit-source-folder-modal',
    templateUrl: './edit-source-folder-modal.component.html',
    styleUrls: ['./edit-source-folder-modal.component.scss'],
    standalone: true,
    imports: [
      ReactiveFormsModule,
      MatFormField,
      MatInput,
      MatError,
      MatChipGrid,
      MatChipRow,
      MatChipRemove,
      MatIcon,
      MatChipInput,
      MatButton,
    ],
})
export class EditSourceFolderModalComponent implements OnInit {
  public editFolderForm: FormGroup;
  public keywordControl = new FormControl('');
  public keywords: string[] = [];

  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;

  constructor(
    private fb: FormBuilder,
    private _folderService: FoldersService,
    private _commonService: CommonService,
    private dialogRef: MatDialogRef<EditSourceFolderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { source: TFolderItem }
  ) {
    this.editFolderForm = this.fb.nonNullable.group({
      name: [''],
    });
  }

  public ngOnInit(): void {
    if (this.data.source) {
      this.editFolderForm.patchValue({
        name: this.data.source.name,
      });
      // Load existing keywords
      this.keywords = this.data.source.keywords ? [...this.data.source.keywords] : [];
    }
  }

  public get name() {
    return this.editFolderForm.get('name')!;
  }

  public addKeyword(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value && !this.keywords.includes(value)) {
      this.keywords.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();
    this.keywordControl.setValue('');
  }

  public removeKeyword(keyword: string): void {
    const index = this.keywords.indexOf(keyword);
    if (index >= 0) {
      this.keywords.splice(index, 1);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  public updateFolder(): void {
    const updatedFolder = {
      ...this.data.source,
      name: this.name.value,
      keywords: this.keywords,
    };
    this._folderService.updateFolder(updatedFolder, () => {
      this._commonService.openSuccessSnackBar('Folder updated');
      this.dialogRef.close();
    });
  }
}
